import Client from '../client';
import BaseService from '../baseService/baseService';
import { AxiosResponse } from 'axios';

const LimiteComissaoService = {
    salvarParametrosExcel(fileRequest: any) {
        return BaseService.conectarEndpoint(fileRequest, 'compensation/limite-comissao/excel', 'limiteComissaoExcelSalvar');
    },
    baixarParametrosExcel(): Promise<void | AxiosResponse<any>> {
        return Client.getBlob('compensation/limite-comissao/excel');
    },
    deletarParametrosExcel(request: any) {
        return BaseService.conectarEndpoint(request, 'compensation/limite-comissao/deletar', 'limiteComissaoDeletar');
    },
    reenviarParametrosExcel(): Promise<void | AxiosResponse<any>> {
        return Client.post('compensation/limite-comissao/eventGrid', {});
    }
};

export default LimiteComissaoService;
